function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "strattic-logo-1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1.16 5.81a1.16 1.16 0 010-2.32h13.69a1.16 1.16 0 110 2.32zm12.9 9.41a1.16 1.16 0 011.59 1.7 12.28 12.28 0 01-3.6 2.35 10.32 10.32 0 01-8.11 0 11.71 11.71 0 01-3.6-2.35 1.19 1.19 0 01-.06-1.64 1.2 1.2 0 011.65-.06 9.59 9.59 0 002.89 1.9 8.11 8.11 0 003.18.62 8.5 8.5 0 003.18-.62 9.59 9.59 0 002.88-1.9zm.31-5.92a1.15 1.15 0 111 2.09 17.77 17.77 0 01-3.48 1.17A19.36 19.36 0 018 13a19.26 19.26 0 01-3.85-.39 14.61 14.61 0 01-3.5-1.22 1.18 1.18 0 01-.56-1.53 1.18 1.18 0 011.53-.56 13.27 13.27 0 003 1 15.78 15.78 0 003.38.3 15.87 15.87 0 003.38-.34 15.44 15.44 0 003-1z",
  fill: "#fefefe",
  "data-name": 876625776
}));

function SvgLogo3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "strattic-logo",
    viewBox: "0 0 16.02 20.1"
  }, props), _ref);
}

export default SvgLogo3;